import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

import { storeToRefs } from 'pinia'
import { computed, onMounted, ref, watch } from 'vue'
import { RouteLocationRaw, useRouter } from 'vue-router'

import Button from '@/components_new/Button.vue'
import TaskWidget from '@/components_new/TaskItems/TaskWidget.vue'
import TaskWidgetPlaceholder from '@/components_new/TaskItems/TaskWidgetPlaceholder.vue'
import { useTasksStore } from '@/components_new/TaskItems/store'
import Typography from '@/components_new/Typography.vue'
import { ROUTE_NAMES } from '@/router/constants'
import { useUserStore } from '@/store/user-store/user-store'
import { TaskDto } from '@/types'
import { useIsMounted } from '@/utils/vue-hooks/use-is-mounted'

interface TasksWidgetProps {
    redirect?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TasksWidget',
  props: {
    redirect: { type: Boolean }
  },
  setup(__props: any) {

const hide = ref(false)
const show = ref(false)
const isMounted = useIsMounted()
const props = __props

const tasksStore = useTasksStore()
const userStore = useUserStore()
const { tasksError, allTasksClaimed, firstTask, isClaimStarted } = storeToRefs(tasksStore)

const task = ref<TaskDto | undefined>(undefined)

onMounted(() => {
    if (!task.value && firstTask.value) {
        task.value = firstTask.value
    }
})

function onAnimationEnd() {
    if (hide.value) {
        task.value = firstTask.value
        hide.value = false
        show.value = true
    }
}

watch(firstTask, (newFirstTask, oldFirstTask) => {
    if (!task.value) {
        task.value = newFirstTask
        return
    }

    if (oldFirstTask?.task_id === newFirstTask?.task_id && oldFirstTask?.status === newFirstTask?.status) {
        return
    }

    hide.value = true
    show.value = false
})

const { isAuthorized, isUserInfoLoaded } = storeToRefs(userStore)

const isLoading = computed(() => {
    if (!isMounted.value) {
        return true
    } else if (!isUserInfoLoaded.value) {
        //while we are waiting for user info
        return true
    } else if (!isAuthorized.value) {
        //if not logged in - stop loading and show RegisterTask
        return false
    } else if (task.value) {
        // if loggged in, wait for tasks
        return false
    } else {
        return true
    }
})

const router = useRouter()

const onTaskClaim = (incomingTask: TaskDto) => {
    tasksStore.onTaskClaimed(incomingTask)
}

const onTaskClick = () => {
    if (props.redirect) {
        router.push({ name: ROUTE_NAMES.PROFILE })
    }
}
const onTaskStart = ({ taskId, link }: { taskId: string; link: RouteLocationRaw }) => {
    tasksStore.onTaskStart(taskId)
    router.push(link)
}

return (_ctx: any,_cache: any) => {
  return (!_unref(allTasksClaimed))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.$style.componentContainer),
        "data-interface-section": "tasks-widget"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.tasksWidget, { [_ctx.$style.rotateOut]: hide.value, [_ctx.$style.rotateIn]: show.value }]),
          onAnimationend: onAnimationEnd
        }, [
          (isLoading.value)
            ? (_openBlock(), _createBlock(TaskWidgetPlaceholder, { key: 0 }))
            : (_unref(isAuthorized))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (!_unref(tasksError))
                    ? (_openBlock(), _createBlock(TaskWidget, {
                        key: 0,
                        task: task.value,
                        clickable: props.redirect,
                        disabled: _unref(isClaimStarted),
                        onClaimTask: onTaskClaim,
                        onTaskStart: onTaskStart,
                        onTaskClick: onTaskClick
                      }, null, 8, ["task", "clickable", "disabled"]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(_ctx.$style.errorContainer)
                      }, [
                        _createVNode(Typography, {
                          type: "paragraph",
                          size: "xs"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$tr('tasks.error_title')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(Button, {
                          color: "carbon-400",
                          visual: "fill",
                          interfaceTarget: "reload-tasks",
                          onClick: _unref(tasksStore).onReloadClick
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$tr('tasks.error_button')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ], 2))
                ], 64))
              : (_openBlock(), _createBlock(TaskWidget, {
                  key: 2,
                  isRegister: true,
                  clickable: true
                }))
        ], 34)
      ], 2))
    : _createCommentVNode("", true)
}
}

})